import './vendor';
import './helpers';
import Swiper from 'swiper/dist/js/swiper';
import select2 from 'select2';
import { fancybox } from '@fancyapps/fancybox';
import inputmask from 'inputmask/dist/jquery.inputmask';
import videojs from 'video.js';
import 'jquery-validation';
import '../../node_modules/jquery-validation/dist/additional-methods.js';
import '../../node_modules/jquery-validation/dist/localization/messages_ru.js';
import noUiSlider from 'nouislider';
import wNumb from 'wnumb';
import analytics from './analytics';

const $document = $(document);

const $window = $(window);

const $html = $('html');

const $body = $('body');

$.validator.addMethod(
    "regex",
    function (value, element, regexp) {
        if (regexp && regexp.constructor != RegExp) {
            regexp = new RegExp(regexp[0], regexp[1]);
        } else if (regexp.global) regexp.lastIndex = 0;
        return this.optional(element) || regexp.test(value);
    },
    "Неверный формат",
);

const app = {
	isMobile: () => $window.outerWidth() < 1024,
	global: {
		init() {
			$('.js-goto').on('click', (e) => {
				let $target = $($(e.currentTarget).data('target') || $(e.currentTarget).attr('href'));

				if ($target.length) {
					e.preventDefault();
					$('html, body').animate({
						scrollTop: $target.offset().top - 120,
					}, 400);
				}
			});

			$('[data-fancybox]').fancybox({
				autoFocus: false,
				backFocus: false,
				touch: false,
				afterShow() {
					$('.fancybox-container:visible .c-progress__tabs button.is-active').trigger('click');
				},
				beforeClose() {
					$('.fancybox-container:visible .c-progress__video').each((index, item) => {
						const $item = $(item);

						const $video = $item.find('video');

						videojs($video[0]).dispose();
					});
				},
			});

			let touchX = 0;
			let triggerTouchStart = 0;

			$document.on('touchstart', '.fancybox-close-small', (e) => {
				touchX = e.touches[0].clientY;
				triggerTouchStart = 0;
			});

			$document.on("touchmove", '.fancybox-close-small', (e) => {
				triggerTouchStart = (touchX - e.touches[0].clientY);

				if (triggerTouchStart < 0) {
					$(e.currentTarget).closest('.fancybox-content').css({
						transform: `translateY(${-triggerTouchStart}px)`,
					});
				}
			});

			$document.on("touchend", '.fancybox-close-small', (e) => {
				if (triggerTouchStart < -25) {
					$.fancybox.close();
					setTimeout(() => {
						$('.modal').css({
							transform: '',
						});
					}, 500);
				} else {
					$(e.currentTarget).closest('.fancybox-content').css({
						transform: '',
					});
				}
			});

			$document.on('click', '.js-toggle-class', (e) => {
				e.preventDefault();

				let options = $(e.currentTarget).data();

				switch (options.type) {
					case 'add':
						$html.addClass(options.class);
						break;
					case 'remove':
						$html.removeClass(options.class);
						break;
					case 'toggle':
						$html.toggleClass(options.class);
						break;
					default:
						$html.toggleClass(options.class);
						break;
				}
			});

			$('.js-show-hide').on('click', (e) => {
				let $this = $(e.currentTarget);

				let $target = $($this.data('target'));

				e.preventDefault();
				if ($target.length) {
					$this.toggleClass('is-active');
					if ($this.hasClass('is-active')) {
						$target.stop().slideDown(500);
						$this.find('span').text($this.data('on'));
					} else {
						$target.stop().slideUp(500);
						$this.find('span').text($this.data('off'));
					}
				}
			});

			$('.js-print').on('click', (e) => {
				e.preventDefault();
				window.print();
			});

			$('.tabs-video-js .tab-inner').on('click', (e) => {

				let $progress = $('div.modal.c-progress');

				let $video = $progress.find('.c-progress__video');

				let player;

				let $videoSrc = $(e.currentTarget).data('src');

					if ($video.find('video').length) {
						videojs($video.find('video')[0]).dispose();
					}

					var overrideNative = false;

					$video.append(`<video class="video-js"><source src="${$videoSrc}""></video>`);

					const video = $video.find('video')[0];

					player = videojs(video, {
						html5: {
							// fill: true,
							fluid: true,
							liveTracker: {
								trackingThreshold: 5
							},
							hls: {
								overrideNative: !videojs.browser.IS_SAFARI,
							},
							nativeVideoTracks: !overrideNative,
							nativeAudioTracks: !overrideNative,
							nativeTextTracks: !overrideNative
						}
					});

					player.playsinline(true);
					player.play();

				$progress.find('.c-progress__fullscreen').on('click', (e) => {
					player.requestFullscreen();
				});

				$progress.find('.c-progress__vertical__close').on('click', (e) => {
					$progress.find('.c-progress__vertical').addClass('is-hidden');
				});
			});
		},
	},
	header: {
		init($header) {
			$window.on('scroll', () => {
				if ($window.scrollTop() > $header.outerHeight()) {
					$html.addClass('is-header-fixed');
				} else {
					$html.removeClass('is-header-fixed');
				}
			}).trigger('scroll');
		},
	},
	indexHero: {
		init($hero) {
			const $video = $hero.find('.index-hero__video video');

			$video.prop('src', app.isMobile() ? $video.data('mobile') : $video.data('desktop'));
		},
	},
	location: {
		init($location) {
			let $map = $location.find('.location__map');

			let options = $map.data();

			app.scriptLoading('//api-maps.yandex.ru/2.1/?lang=ru_RU', () => {
				ymaps.ready(() => {
					let map = new ymaps.Map($map[0], {
						center: [options.lat, options.lng],
						zoom: options.zoom,
						controls: [],
					}, {});

					map.geoObjects.add(new ymaps.Placemark([options.lat, options.lng], {}, {
						iconLayout: 'default#image',
						iconImageHref: options.icon,
						iconImageSize: [32, 32],
						iconImageOffset: [-16, -32],
					}));
				});
			});
		},
	},
	indexItem: {
		init($item) {
			let $videos = $item.find('.index-item__slide__video');

			let stopVideos = () => {
				$videos.each((index, item) => {

					if (!$(item).hasClass('is-autoplay')) {
						if (!item.paused) {
							item.pause()
							item.currentTime = 0;

							$(item).hide();
						}
					}
				});
			}

			$item.find('.swiper-slide:hidden').remove();

			if ($item.find('.swiper-slide').length > 1 && (app.isMobile() || !$item.hasClass('index-item--grid'))) {
				let $menu = $item.find('.index-item__menu');

				let slider = new Swiper($item.find('.swiper-container'), {
					loop: false,
					effect: !app.isMobile() && $item.hasClass('index-item--content') && !$item.hasClass('index-item--content-static') ? 'fade' : 'slide',
					preloadImages: false,
					lazy: true,
					navigation: {
						prevEl: $item.find('.index-item__prev'),
						nextEl: $item.find('.index-item__next'),
					},
					pagination: {
						el: $item.find('.index-item__pager'),
						clickable: true,
					},
				});

				$menu.find('button').on('click', (e) => {
					let $this = $(e.currentTarget);

					e.preventDefault();
					$menu.find('button').removeClass('is-active');
					$this.addClass('is-active');
					slider.slideTo($this.closest('li').index());
				});

				slider.on('slideChange', () => {
					$menu.find('button').removeClass('is-active');
					$menu.find('li').eq(slider.activeIndex).find('button').addClass('is-active');

					stopVideos();
				});
			} else {
				$item.find('[data-background]').each((index, item) => {
					$(item).css({
						backgroundImage: `url(${$(item).data('background')})`,
					});
				});
				$item.find('.index-item__pager').remove();
			}

			$item.find('.index-item__slide__play').on('click', (e) => {
				let $this = $(e.currentTarget);

				let $video = $this.closest('.index-item__slide').find('.index-item__slide__video');

				if ($video.length) {
					stopVideos();

					if ($this.attr('data-fancybox') === undefined) {
						e.preventDefault();

						$video.prop('src', $video.data(app.isMobile() ? 'mobile' : 'desktop')).show();
						$video[0].play();
					}
				}
			});

			$videos.on('click', (e) => {
				let $this = $(e.currentTarget);

				if (!$this.hasClass('is-autoplay')) {
					$this[0].pause();
					$this.hide();
				}
			});

			$videos.each((index, item) => {
				let $video = $(item);

				if ($video.hasClass('is-autoplay')) {
					$video.prop('src', $video.data(app.isMobile() ? 'mobile' : 'desktop')).show();
					$video[0].play();
				}
			});

			if ($item.data('gallery')) {
				$item.on('click', (e) => {
					if (!$(e.target).hasClass('index-item__prev') && !$(e.target).hasClass('index-item__next')) {
						$.fancybox.open($item.data('gallery'), {
						});
					}
				});
			}
		},
	},
	realtyMap: {
		init($map) {
			let slider;

			let catalog = $map.closest('.catalog').length;

			if ($map.find('.swiper-container').length) {
				slider = new Swiper($map.find('.swiper-container'), {
					slidesPerView: 'auto',
					freeMode: true,
					roundLengths: true,
					freeModeMomentumRatio: 0.1,
					grabCursor: true,
					scrollbar: {
						el: $map.find('.realty__map__scroll__bar'),
						draggable: true,
						snapOnRelease: false,
					},
				});

				setTimeout(() => {
					slider.update();
				}, 150);

				if(window.localStorage && window.localStorage.aptop){
					if (catalog) {
						window.scrollTo(0, window.localStorage.aptop);
					}
					window.localStorage.removeItem('aptop');
				}

				if(window.localStorage && window.localStorage.apt){
					if (catalog) {
						slider.setTranslate(window.localStorage.apt);
						setTimeout(() => {
							slider.scrollbar.setTranslate(window.localStorage.apt);
						}, 150);
					}

					setTimeout(() => {
						window.localStorage.removeItem('apt');
					}, 300);
				}

				if(window.localStorage && window.localStorage.apid){
					if (catalog) {
						let $path = $map.find(`.realty__map__item__flat[data-id="${window.localStorage.apid}"]`);

						if ($path.length) {
							setTimeout(function(){
								$path.addClass('is-play');

								setTimeout(function(){
									$path.removeClass('is-play');

									setTimeout(function(){
										$path.addClass('is-play');

										setTimeout(function(){
											$path.removeClass('is-play');
										}, 400);
									}, 400);
								}, 400);
							}, 500);
						}
					}
					window.localStorage.removeItem('apid');
				}

				slider.on('setTranslate setTransition', () => {
					window.apt = slider.getTranslate();
				});
			}

			$map.find('.realty__map__item__flat').on('click', (e) => {
				let $this = $(e.currentTarget);

				let $target = $($this.data('target'));

				e.preventDefault();
				if ($target.length) {
					$('.js-realty-area-field').val(`${$this.data('area')}${$('.js-realty-area-field').data('suffix')}`);
					if ($target.is(':visible')) {
						window.scrollTo(0, $target.offset().top - $('.header').outerHeight());
					} else {
						$.fancybox.open({
							src: $this.data('target'),
							touch: false,
							autoFocus: false,
							backFocus: false,
						});
					}
				} else if ($this.data('href')) {
					if (window.localStorage) {
						window.localStorage.apt = window.apt;
						window.localStorage.apid = $this.data('id');
						window.localStorage.aptop = document.documentElement.scrollTop || document.body.scrollTop;
					}
					window.location = $this.data('href');
				}
			});

			$map.find('.realty__map__item__flat').on('mousedown', (e) => {
				let $this = $(e.currentTarget);

				let $target = $($this.data('href'));

				e.preventDefault();
				if (e.which === 2) {
					if ($target.length) {
						$('.js-realty-area-field').val(`${$this.data('area')}${$('.js-realty-area-field').data('suffix')}`);
						if ($target.is(':visible')) {
							window.scrollTo(0, $target.offset().top - $('.header').outerHeight());
						} else {
							$.fancybox.open({
								src: $this.data('href'),
								touch: false,
								autoFocus: false,
								backFocus: false,
							});
						}
					} else if ($this.data('href')) {
						window.location = $this.data('href');
					}
				}
			});

			$map.find('.realty__map__item__flat').on('mousemove', (e) => {
				let $info = $map.find(`.realty__map__info[data-item="${$(e.currentTarget).data('flat')}"]`);

				if ($info.length) {
					let top = e.clientY;

					let left = e.pageX + 15;

					if ($window.outerWidth() - e.pageX < $info.outerWidth()) {
						left = e.pageX - $info.outerWidth() - 15;
						$info.addClass('is-left');
					} else {
						$info.removeClass('is-left');
					}

					if ($window.outerHeight() - 15 < e.clientY + $info.outerHeight()) {
						top = e.pageY - (e.clientY + $info.outerHeight() - $window.outerHeight() + $window.scrollTop()) - 15;
					}

					$info.css({
						top: top,
						left: left,
					}).addClass('is-show');
				}
			}).on('mouseleave', (e) => {
				let $info = $map.find(`.realty__map__info[data-item="${$(e.currentTarget).data('flat')}"]`);

				$info.removeClass('is-show');
			})

			$window.on('load', () => {
				if (slider) {
					slider.update();
				}
			});
		},
	},
	accordion: {
		init($accordion) {
			$accordion.find('.accordion__item__head').on('click', (e) => {
				let $this = $(e.currentTarget);

				let $item = $this.closest('.accordion__item');

				let $content = $item.find('.accordion__item__content');

				e.preventDefault();
				if (!$item.hasClass('is-active')) {
					$accordion.find('.accordion__item.is-active').find('.accordion__item__content').slideUp(250);
					$accordion.find('.accordion__item.is-active').removeClass('is-active');
					$item.addClass('is-active');
					$content.stop().slideDown(250);
				} else {
					$item.removeClass('is-active');
					$content.stop().slideUp(250);
				}
			});
		},
	},
	tabs: {
		init($tabs) {
			let $links = $tabs.find('.js-tabs-link');

			let $items = $tabs.find('.js-tabs-item');

			$links.on('click', (e) => {
				let $this = $(e.currentTarget);

				let $target = $($this.attr('href'));

				e.preventDefault();
				if ($target.length && !$this.hasClass('is-active')) {
					$links.removeClass('is-active');
					$links.filter(`[href="${$this.attr('href')}"]`).addClass('is-active');
					$items.removeClass('is-active');
					$target.addClass('is-active');

					if ($tabs.data('callback') === 'carousel') {
						$target.data('slider')();
					}
					if ($tabs.data('callback') === 'catalog') {
						$tabs.find(`[data-block="${$target.data('show-block')}"]`).show();
						$tabs.find(`[data-block="${$target.data('hide-block')}"]`).hide();
					}
				}
			});
		},
	},
	select: {
		init($select) {
			$select.find('select').select2({
				minimumResultsForSearch: $select.data('search') ? 5 : Infinity,
				dropdownParent: $select.find('.input__field'),
			});
		},
	},
	mask: {
		init($mask) {
			$mask.inputmask($mask.data('mask').toString(), {
				showMaskOnHover: false,
				clearIncomplete: true,
			});
		},
	},
	select: {
		init($select) {
			$select.find('select').select2({
				minimumResultsForSearch: Infinity,
				dropdownParent: $select.find('.input__field'),
			});
		},
	},
	triggerComagic(arName, arPhone, arMessage, arMail){
        console.log(arName, arMail, arPhone, arMessage);
		Comagic.addOfflineRequest({
			name: arName,
			phone: arPhone,
			message: arMessage,
		});
    },
	form: {
		init($form) {
			let disabled = false;

			$form.on('change', '.form-field input[type="file"]', (e) => {
				let $this = $(e.currentTarget);

				let $parent = $this.closest('.form-field');

				let $label = $parent.find('.form-field__file span');

				if (e.target.files.length === 0) {
					$label.text($label.data('label').split('||')[0]);
				} else if (e.target.files.length === 1) {
					$label.text(e.target.files[0].name);
				} else {
					$label.text($label.data('label').split('||')[1].replace('{$count}', e.target.files.length));
				}
			});

			let validator = $form.validate({
				lang: 'ru',
				rules: {
					'password': {
						minlength: 6,
					},
					'password-confirm': {
						equalTo: $form.find('[name="password"]')[0],
					},
				},
				messages: {
					'password-confirm': 'Ошибка! Пароли не совпадают',
				},
				highlight(element) {
					$(element).closest('.input, .checkbox').addClass('is-error');
				},
				unhighlight(element) {
					$(element).closest('.input, .checkbox').removeClass('is-error');
				},
				submitHandler(form) {
					if (!disabled) {
						disabled = true;
						$form.addClass('is-send-process');
						if ($form.data('type') === 'submit') {
							form.submit();
						} else {
							let preparedData;

							let processData;

							let contentType;

							$form.removeClass('is-sended is-error');

							if ($form.find('input[type="file"]').length > 0) {
								preparedData = new FormData($form.get()[0]);
								processData = false;
								contentType = false;
							}

							$.ajax({
								type: $form.attr('method'),
								url: $form.attr('action'),
								data: preparedData ? preparedData : $form.serialize(),
								dataType: $form.data('type') === 'status' ? 'html' : 'json',
								processData: processData,
								contentType: contentType,
								success(result) {
									if (result.result === true) {
										// Создание заявки на обратный звонок
										window.ctw.getRouteKeyData('izm_park', function(success, data){
											console.log(success, data);
											if (success) {
												if (data.widgetFound) {
													if (data.widgetData.callCenterWorkingMode == 'working_hours') {
														console.log('колл-центр работает, отображение виджета');
													} else {
														if (data.widgetData.collectNonWorkingRequests) {
															console.log('колл-центр не работает, но можем отобразить форму нерабочего времени');
														} else {
															console.log('колл-центр не работает, заявки в нерабочее время не собираем');
														}
													}
												} else {
													console.log('не найден включенный виджет по routeKey, либо услуга обратного звонка не активна');
												}
											} else {
												console.log('во время обработки произошла ошибка');
												console.log(data)
											}
										});

										window.ctw.createRequest(
											'izm_park',
											$form.find('input[name="phone"]').val().replace(/[\+\s]/g, ''),
											[
												{"name": "FIO", "value": $form.find('input[name="name"]').val()},
											],
											function(success, data){
												console.log(success, data)
												if (success) {
													console.log('Создана заявка на колбек, идентификатор: ' + data.callbackRequestId)
												} else {
													switch(data.type) {
														case "request_throttle_timeout":
														case "request_throttle_count":
															console.log('Достигнут лимит создания заявок, попробуйте позже');
															break;
														case "request_phone_blacklisted":
															console.log('номер телефона находится в черном списке');
															break;
														case "validation_error":
															console.log('были переданы некорректные данные');
															break;
														default:
															console.log('Во время выполнения запроса произошла ошибка: ' + data.type);
													}
												}
											},
											null,
											[],
											null,
										)
										// END Создание заявки на обратный звонок
										if (typeof Comagic !== 'undefined') {
											app.triggerComagic(
												$form.find('[name="name"]').val(),
												$form.find('[name="phone"]').val(),
												$form.find('[name="apartment-number"]').val(),
											)
										}

										$form[0].reset();
										$.fancybox.close();
										if (typeof dataLayer !== 'undefined') {
											analytics.formSend($form.data('name'));
										}

									}
									$.fancybox.open(`<div class="modal modal--success">
										<div class="modal__title">${result.title}</div>
										<div class="modal__text">${result.message}</div>
									</div>`, {
										autoFocus: false,
										touch: false,
									});
									disabled = false;
									$form.removeClass('is-send-process');
								},
							});
						}
					}
				},
			});

			setTimeout(() => {
				$form.find('[data-validation]').each((index, item) => {
					$(item).rules('add', $(item).data('validation'));
				});
			}, 1000);
		},
	},
	contactsMap: {
		init($map) {
			let options = $map.data();

			app.scriptLoading('//api-maps.yandex.ru/2.1/?lang=ru_RU', () => {
				ymaps.ready(() => {
					let map = new ymaps.Map($map[0], {
						center: [options.lat, options.lng],
						zoom: options.zoom,
						controls: [],
					}, {});

					map.geoObjects.add(new ymaps.Placemark([options.lat, options.lng], {}, {
						iconLayout: 'default#image',
						iconImageHref: options.icon,
						iconImageSize: [32, 32],
						iconImageOffset: [-16, -32],
					}));
				});
			});
		},
	},
	scriptLoading(src, callback) {
		let script = document.createElement('script');

		let loaded;

		script.setAttribute('src', src);
		if (callback) {
			script.onreadystatechange = script.onload = () => {
				if (!loaded) {
					callback();
				}
				loaded = true;
			};
		}
		document.getElementsByTagName('head')[0].appendChild(script);
	},
	catalog: {
		init($catalog) {
			const $map = $catalog.find('.realty__map');

			const $floorFree = $catalog.find('.catalog__floor__free');

			const $floorChange = $catalog.find('.js-catalog-change-floor');

			const $select = $catalog.find('.catalog__floor__select');

			const $selectLabel = $catalog.find('.catalog__floor__select__label');

			const $selectDrop = $catalog.find('.catalog__floor__select__drop');

			const $title = $catalog.find('.js-catalog-title');

			let filterData = {
			};


			const setFloor = (number) => {
				$catalog.data('floor', number);
				filterData.floor = number;
				localStorage.filterDataVisual = JSON.stringify(filterData);
				$select.removeClass('is-show-drop');
				$map.addClass('is-loading');
				$title.addClass('is-hidden');
				if (window.localStorage && window.apt && number !== 'parking' && number !== 'realty') {
					window.localStorage.apt = window.apt;
				}
				if ($title.filter(`[data-for="${number}"]`).length) {
					$title.filter(`[data-for="${number}"]`).removeClass('is-hidden');
				} else {
					$title.filter('[data-for="default"]').removeClass('is-hidden');
				}
				$floorChange.removeClass('is-active');
				$floorChange.filter(`[data-floor="${$catalog.data('floor')}"]`).addClass('is-active');
				$selectLabel.text($floorChange.filter('.is-active').data('title'));
				$.ajax({
					type: 'get',
					url: $catalog.data('ajax'),
					data: {
						floor: $catalog.data('floor'),
					},
					success(response) {
						$map.html(response);
						$floorFree.addClass('is-hidden');
						$floorFree.filter(`[data-floor="${number}"]`).removeClass('is-hidden');
						$map.data('realty-map-init', '');
						$select.removeClass('is-show-drop');
						$map.removeClass('is-loading');
						if (number === 'parking') {
							$catalog.addClass('catalog--dark');
						} else {
							$catalog.removeClass('catalog--dark');
						}
						initApps();
					},
				});
			};

			const prevFloor = () => {
				const $selectedFloor = $selectDrop.find(`.js-catalog-change-floor[data-floor="${$catalog.data('floor')}"]`);

				const $prevFloor = $selectedFloor.closest('li').prev('li').find('.js-catalog-change-floor');

				if ($prevFloor.length) {
					setFloor($prevFloor.data('floor'));
				}
			}

			const nextFloor = () => {
				const $selectedFloor = $selectDrop.find(`.js-catalog-change-floor[data-floor="${$catalog.data('floor')}"]`);

				const $nextFloor = $selectedFloor.closest('li').next('li').find('.js-catalog-change-floor');

				if ($nextFloor.length) {
					setFloor($nextFloor.data('floor'));
				}
			}

			if (localStorage.filterDataVisual) {
				$.extend(filterData, JSON.parse(localStorage.filterDataVisual));
			}

			$floorChange.on('click', (e) => {
				let $this = $(e.currentTarget);

				e.preventDefault();
				switch($this.data('floor')) {
					case 'minus':
						prevFloor();
						break;
					case 'plus':
						nextFloor();
						break;
					default:
						setFloor($this.data('floor'));
				}
			});

			$selectLabel.on('click', (e) => {
				e.preventDefault();
				$select.toggleClass('is-show-drop');
			});

			$document.on('click', (e) => {
				let $target = $(e.target);

				if (!$target.closest('.catalog__floor__select').length) {
					$('.catalog__floor__select').removeClass('is-show-drop');
				}
			});

			setFloor(filterData.floor ? 24 : $catalog.data('floor'));

			window.addEventListener('pageshow',function(e) {
				if (e.persisted) {
					setFloor(filterData.floor ? filterData.floor : $catalog.data('floor'));
				}
			});
		},
	},
	catalogFilter: {
		init($catalog) {
			const $floorChange = $catalog.find('.js-catalog-change-floor');

			const $rooms = $catalog.find('.catalog__filter__rooms input');

			const $floorInput = $catalog.find('.catalog__floor__input');

			const $select = $catalog.find('.catalog__floor__select');

			const $selectLabel = $catalog.find('.catalog__floor__select__label');

			const $selectDrop = $catalog.find('.catalog__floor__select__drop');

			const $sortChange = $catalog.find('.js-catalog-change-sort');

			const $sortInput = $catalog.find('.catalog__sort__input');

			const $sortSelect = $catalog.find('.catalog__sort__select');

			const $sortSelectLabel = $catalog.find('.catalog__sort__select__label');

			const $sortSelectDrop = $catalog.find('.catalog__sort__select__drop');

			const $range = $catalog.find('.catalog__filter__range');

			const $filter = $catalog.find('.catalog__filter');

			const $price = $filter.find('.catalog__filter__range__slider--price');

			const $area = $filter.find('.catalog__filter__range__slider--area');

			let getDataTimeout;

			let filterSerialize = '';

			const $list = $catalog.find('.catalog__grid');

			let filterData = {
				rooms: [],
				price: {},
				area: {},
			};

			const getData = (more = false, morePage = 1) => {
				clearTimeout(getDataTimeout);
				if (!more) {
					$list.addClass('is-loading');
				}
				getDataTimeout = setTimeout(() => {
					if(!document.location.href.includes('promo_request=y')){
						localStorage.filterData = JSON.stringify(filterData);
					}else{
						localStorage.filterData = '';
					}
					if ($filter.serialize() !== filterSerialize || more) {
						filterSerialize = $filter.serialize();

						$.ajax({
							type: $filter.attr('method'),
							url: $filter.attr('action'),
							data: filterSerialize + '&p=' + morePage,
							dataType: 'json',
							success(response) {
								if (more) {
									$list.find('.catalog__grid__more').remove();
									$list.append(response.html);
								} else {
									$list.html(response.html);
								}
								$list.removeClass('is-loading');

								if ($price.length && ($price.data('min') !== response.priceMin || $price.data('max') !== response.priceMax)) {
									let currentValues = $price[0].noUiSlider.get();

									$price[0].noUiSlider.updateOptions({
										start: [
											parseInt(currentValues[0], 10) === parseInt($price.data('min'), 10) || parseInt(currentValues[0], 10) > response.priceMin ? response.priceMin : parseInt(currentValues[0], 10),
											parseInt(currentValues[1], 10) === parseInt($price.data('max'), 10) || parseInt(currentValues[1], 10) < response.priceMax ? response.priceMax : parseInt(currentValues[1], 10)
										],
										range: {
											min: response.priceMin,
											max: response.priceMax,
										},
									});
									$price.data('min', response.priceMin);
									$price.data('max', response.priceMax);
								}

								if ($area.length && ($area.data('min') !== response.areaMin || $area.data('max') !== response.areaMax)) {
									let currentValues = $area[0].noUiSlider.get();

									$area[0].noUiSlider.updateOptions({
										start: [
											parseInt(currentValues[0], 10) === parseInt($area.data('min'), 10) || parseInt(currentValues[0], 10) > response.areaMin ? response.areaMin : parseInt(currentValues[0], 10),
											parseInt(currentValues[1], 10) === parseInt($area.data('max'), 10) || parseInt(currentValues[1], 10) < response.areaMax ? response.areaMax : parseInt(currentValues[1], 10)
										],
										range: {
											min: response.areaMin,
											max: response.areaMax,
										},
									});
									$area.data('min', response.areaMin);
									$area.data('max', response.areaMax);
								}
							},
						});
					} else {
						$list.removeClass('is-loading');
					}
				}, 500);
			};

			const setFloor = (number) => {
				let $activeFloor = $floorChange.filter(`[data-floor="${number}"]`);

				if ($activeFloor.data('href')) {
					window.location = $activeFloor.data('href');
					return false;
				}

				$floorChange.removeClass('is-active');
				$activeFloor.addClass('is-active');
				$floorInput.val(number).trigger('change');
				$selectLabel.text($floorChange.filter('.is-active').data('title'));
				$select.removeClass('is-show-drop');
				filterData.floor = number;
			};

			const prevFloor = () => {
				const $selectedFloor = $selectDrop.find(`.js-catalog-change-floor[data-floor="${$floorInput.val()}"]`);

				const $prevFloor = $selectedFloor.closest('li').prev('li').find('.js-catalog-change-floor');

				if ($prevFloor.length && !$prevFloor.data('href')) {
					setFloor($prevFloor.data('floor'));
				}
			}

			const nextFloor = () => {
				const $selectedFloor = $selectDrop.find(`.js-catalog-change-floor[data-floor="${$floorInput.val()}"]`);

				const $nextFloor = $selectedFloor.closest('li').next('li').find('.js-catalog-change-floor');

				if ($nextFloor.length) {
					setFloor($nextFloor.data('floor'));
				}
			}

			const setFilterData = () => {
				if (localStorage.filterData) {
					$.extend(filterData, JSON.parse(localStorage.filterData));
				}
			}

			const setSort = (number) => {
				let $activeSort = $sortChange.filter(`[data-type="${number}"]`);

				$sortChange.removeClass('is-active');
				$activeSort.addClass('is-active');
				$sortInput.val(number).trigger('change');
				$sortSelectLabel.text($sortChange.filter('.is-active').data('title'));
				$sortSelect.removeClass('is-show-drop');
				// console.log(number)
				filterData.sort = number;
			};




			setFilterData();

			if (filterData) {
				if (filterData.rooms) {
					filterData.rooms.forEach(room => {
						if(!document.location.href.includes('promo_request=y')){
							$rooms.filter(`[value="${room}"]`).not(".promo-input").prop('checked', true);
						}
					});
				}



				if (filterData.floor) {
					$floorChange.removeClass('is-active');
					$floorChange.filter(`[data-floor="${filterData.floor}"]`).addClass('is-active');
					setFloor($floorChange.filter(`[data-floor="${filterData.floor}"]`).data('floor'));
				}

				if (filterData.sort) {
					$sortChange.removeClass('is-active');
					$sortChange.filter(`[data-type="${filterData.sort}"]`).addClass('is-active');
					setSort($sortChange.filter(`[data-type="${filterData.sort}"]`).data('type'));
				}

				if (filterData.renovation) {
					$catalog.find('.catalog__filter__renovation input').prop('checked', filterData.renovation === 'yes');
				}
			};

			$floorChange.on('click', (e) => {
				let $this = $(e.currentTarget);

				e.preventDefault();
				switch($this.data('floor')) {
					case 'minus':
						prevFloor();
						break;
					case 'plus':
						nextFloor();
						break;
					default:
						setFloor($this.data('floor'));
				}
			});

			$selectLabel.on('click', (e) => {
				e.preventDefault();
				$select.toggleClass('is-show-drop');
			});

			$sortChange.on('click', (e) => {
				let $this = $(e.currentTarget);

				e.preventDefault();
				setSort($this.data('type'));
			});

			$sortSelectLabel.on('click', (e) => {
				e.preventDefault();
				$sortSelect.toggleClass('is-show-drop');
			});

			$document.on('click', (e) => {
				let $target = $(e.target);

				if (!$target.closest('.catalog__floor__select').length) {
					$('.catalog__floor__select').removeClass('is-show-drop');
				}

				if (!$target.closest('.catalog__sort__select').length) {
					$('.catalog__sort__select').removeClass('is-show-drop');
				}
			});

			$range.each((index, item) => {
				let $item = $(item);
				let $from = $item.find('.catalog__filter__range__from');
				let $to = $item.find('.catalog__filter__range__to');
				let $slider = $item.find('.catalog__filter__range__slider');
				let preventChangeFrom = false;
				let preventChangeTo = false;
				let startValues = [
					parseInt(filterData && filterData[$slider.data('type')] && filterData[$slider.data('type')].min ? filterData[$slider.data('type')].min : $slider.data('min'), 10),
					parseInt(filterData && filterData[$slider.data('type')] && filterData[$slider.data('type')].max ? filterData[$slider.data('type')].max : $slider.data('max'), 10)
				];

				noUiSlider.create($slider[0], {
					start: [parseInt(startValues[0], 10), parseInt(startValues[1], 10)],
					step: 1,
					connect: true,
					range: {
						min: parseInt($slider.data('min'), 10),
						max: parseInt($slider.data('max'), 10),
					},
					format: wNumb({
						decimals: 0,
					}),
				});

				$slider[0].noUiSlider.on('update', (values) => {
					preventChangeFrom = true;
					preventChangeTo = true;
					$from.val(values[0]).trigger('change');
					$to.val(values[1]).trigger('change');
					filterData[$slider.data('type')].min = values[0];
					filterData[$slider.data('type')].max = values[1];
					preventChangeFrom = false;
					preventChangeTo = false;
				});

				$slider[0].noUiSlider.on('change', (values) => {
				});

				$from.on('change', (e) => {
					if (!preventChangeFrom) {
						$slider[0].noUiSlider.set([parseInt($from.val(), 10), null]);
					}
				});

				$to.on('change', (e) => {
					if (!preventChangeTo) {
						$slider[0].noUiSlider.set([null, parseInt($to.val(), 10)]);
					}
				});
			});

			$filter.on('change', () => {
				getData();
			});

			$list.on('click', '.catalog__grid__more a', (e) => {
				e.preventDefault();

				$(e.currentTarget).addClass('is-loading');
				getData(true, $(e.currentTarget).data('value'));
			});

			$list.on('click', '.catalog__grid__item__button button', (e) => {
				e.preventDefault();

				$('.js-catalog-order-apartment').val($(e.currentTarget).data('value'))
				$('.js-apartment-number-field').val($(e.currentTarget).data('value'))
				$.fancybox.open({
					src: '#get-offer',
					touch: false,
					autoFocus: false,
					backFocus: false,
				});

			});
			$rooms.on('change', () => {
				filterData.rooms = [];
				$rooms.each((index, item) => {
					if ($(item).is(':checked')) {
						filterData.rooms.push($(item).val());
					}
				});
			});

			$catalog.find('.catalog__filter__renovation input').on('change', (e) => {
				filterData.renovation = $(e.currentTarget).is(':checked') ? 'yes' : '';
			});

			getData();
		},
	},
	catalogType: {
		init($type) {
			$type.find('.catalog__type__label').on('click', (e) => {
				let $this = $(e.currentTarget);

				e.preventDefault();
				$type.toggleClass('is-show');
			});

			$document.on('click', (e) => {
				let $target = $(e.target);

				if (!$target.closest('.catalog__type').length) {
					$('.catalog__type').removeClass('is-show');
				}
			});
		},
	},
	apartment: {
		init($apartment) {
			const $price = $apartment.find('.js-apartment-price');

			const $priceSquare = $apartment.find('.js-apartment-price-square');

			$('.js-apartment-number-field').val($('.apartment__number').text().trim());

			$apartment.find('.apartment__block--drop .apartment__block__label').on('click', (e) => {
				let $this = $(e.currentTarget);

				let $parent = $this.closest('.apartment__block');

				let $content = $parent.find('.apartment__block__content');

				e.preventDefault();
				$this.toggleClass('is-active');
				if ($this.hasClass('is-active')) {
					$content.stop().slideDown(250);
				} else {
					$content.stop().slideUp(250);
				}
			});

			$apartment.find('.apartment__share__open').on('click', (e) => {
				e.preventDefault();
				$apartment.find('.apartment__share').addClass('is-show');
			});

			$apartment.find('.apartment__share__close').on('click', (e) => {
				e.preventDefault();
				$apartment.find('.apartment__share').removeClass('is-show');
			});

			$apartment.find('.apartment__renovation input').on('change', (e) => {
				if ($apartment.find('.apartment__renovation input').is(':checked')) {
					$price.text($price.data('finishing'));
					$priceSquare.text($priceSquare.data('finishing'));
					$('.js-apartment-price').val(app.numberWithoutSpaces($price.data('finishing')));
					$('.js-apartment-price-square').val(app.numberWithoutSpaces($priceSquare.data('finishing')));
					$('.js-apartment-renovation').val(1);
				} else {
					$price.text($price.data('default'));
					$priceSquare.text($priceSquare.data('default'));
					$('.js-apartment-price').val(app.numberWithoutSpaces($price.data('default')));
					$('.js-apartment-price-square').val(app.numberWithoutSpaces($priceSquare.data('default')));
					$('.js-apartment-renovation').val(0);
				}
			});

			if (window.history && document.referrer) {
				$('.js-apartment-back').on('click', (e) => {
					let $this = $(e.currentTarget);

					if(document.referrer.indexOf($this.data('grid')) > -1){
						e.preventDefault();
						location.href = $this.data('grid');
					}
				});
			}

			$document.on('click', (e) => {
				let $target = $(e.target);

				if (!$target.closest('.apartment__share').length) {
					$('.apartment__share').removeClass('is-show');
				}
			});

			// fancy preview

            $('[data-fancybox="apartment"]').fancybox({
                loop: true,
                animationEffect: "fade",
                baseClass: "apart-fancy",
                media : {
                    youtube : {
                        params : {
                            autoplay : 0
                        }
                    }
                }
            });

		},
	},
	equipment: {
		init($equipment) {
			let $buttons = $equipment.find('.equipment__list button');

			let $items = $equipment.find('.equipment__item');

			$buttons.on('click', (e) => {
				let $this = $(e.currentTarget);

				e.preventDefault();
				$buttons.removeClass('is-active');
				$items.removeClass('is-active');
				$this.addClass('is-active');
				$items.filter(`[data-item="${$this.data('item')}"]`).addClass('is-active');
			});
		},
	},
	parking: {
		init($parking) {
			let $items = $parking.find('.parking__item');

			let $tooltips = $parking.find('.parking__tooltip');

			let $map = $parking.find('.realty__map__item');

			$items.hover(
				(e) => {
					let $this = $(e.currentTarget);

					let $tooltip = $tooltips.filter(`[data-item="${$this.data('item')}"]`);

					$tooltip.css({
						left: $this.offset().left - $map.offset().left,
						top: $this.offset().top - $map.offset().top,
					});
					$tooltip.addClass('is-show');
				},
				(e) => {
					let $this = $(e.currentTarget);

					let $tooltip = $tooltips.filter(`[data-item="${$this.data('item')}"]`);

					$tooltip.removeClass('is-show');
				}
			);

			$items.on('click', (e) => {
				let $this = $(e.currentTarget);

				e.preventDefault();
				if (!$(e.currentTarget).hasClass('parking__item--reserved')) {
					$('.js-parking-number').text($this.data('number'));
					$('.js-parking-number-field').val($this.data('number'));
					$('.js-parking-area').text($this.data('area'));
					$('.js-parking-price').text($this.data('price'));
					$.fancybox.open({
						src: '#reserve-number',
						touch: false,
						autoFocus: false,
						backFocus: false,
					});
				}
			});
		},
	},
	numberWithSpaces(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	},
	numberWithoutSpaces(x) {
		return parseInt(x.toString().replace(/ /g, ''), 10);
	},
	calculator: {
		init($thisModule) {

			var Profiles = window.izmCalcData;

			var Params = {
				init:false,
				profile:{
					bank: 'sber',
					rate: 10.1,
					incomeRate: .3,
                    payment:{
                        from: .1,
                        to: .97,
                    },
					period:{
                        from: 3,
                        to: 30,
					}
				},
				hash:'',
				price:{},
				payment:{},
				period:{},
			};

			var Loan = {
				rate: null,				// ставка годовая с учетом скидок, %
                price: null,			// стоимость недвижимости, руб
				paymentInit: null,		// первоначальный взнос, руб
				paymentPercent: null,	// первоначальный взнос в процентах от стоимости квартиры, %
                payment: null,			// первоначальный взнос со всеми скидками (мат капитал), руб
                period: null,			// Срок кредита, лет
				monthly: null,			// ежемесячный платеж, руб
				sum: null,				// сумма кредита, руб
				sumReal: null,			// реальная сумма кредита для формулы, руб
				income: null,			// необходимый доход, руб,
			};

			var Nodes = {
				form: $thisModule.find('[data-n="form"]'),
                fieldPrice: $thisModule.find('[data-n="rangePrice"]'),
                fieldPayment: $thisModule.find('[data-n="rangePayment"]'),
                fieldPeriod: $thisModule.find('[data-n="rangePeriod"]'),
                swiperProfileButtons: $thisModule.find('[data-n="swiperProfileButtons"]'),
				buttonProfile: $thisModule.find('[data-n="buttonProfile"]'),
                labelPaymentPercent: $thisModule.find('[data-n="labelPaymentPercent"]'),
				labelRate: $thisModule.find('[data-n="labelRate"]'),
                labelMonthly: $thisModule.find('[data-n="labelMonthly"]'),
                labelSum: $thisModule.find('[data-n="labelSum"]'),
                labelIncome: $thisModule.find('[data-n="labelIncome"]'),
                buttonSchedule: $thisModule.find('[data-n="buttonSchedule"]'),
				buttonShareOpen: $thisModule.find('[data-n="buttonShareOpen"]'),
				buttonShareClose: $thisModule.find('[data-n="buttonShareClose"]'),
				shareList: $thisModule.find('[data-n="shareList"]'),
			};

			var Methods = {
				init:function() {

					// setup swiper
					var swiper = new Swiper(Nodes.swiperProfileButtons, {
                        slidesPerView: 'auto',
                        roundLengths: true,
                        resizeObserver: true,
                        navigation: {
                            nextEl: $thisModule.find('.bank-link-arrow.arrow-next'),
                            prevEl: $thisModule.find('.bank-link-arrow.arrow-prev'),
                        },
					});

					// setup events
                    Nodes.buttonProfile.on('click', Methods.eventChangeProfile);
                    Nodes.buttonShareOpen.on('click', Methods.shareScheduleOpen);
                    Nodes.buttonShareClose.on('click', Methods.shareScheduleClose);

                    // setup ranges
					Methods.setupRanges();

					// setup ranges events and dependency
					Methods.setupRangesEvents();

                    // setup defaults
                    Nodes.buttonProfile.eq(0).trigger('click');

					// form events
                    Nodes.form.on('change',function(e){
						e.preventDefault();
						Methods.calculateLoan();
                    });

                    Nodes.form.on('submit',function(e){
                    	e.preventDefault();
                    	return false;
					});

                    // ready
                    Params.init = true;

                },
                setupRanges:function(){

					// price range
					Params.price = {
						range: Nodes.fieldPrice.find('.input__range')[0],
                        inputUser: Nodes.fieldPrice.find('.input__field-user'),
						labelFrom: Nodes.fieldPrice.find('.calculator__input-from'),
						labelTo: Nodes.fieldPrice.find('.calculator__input-to'),
					};

                    noUiSlider.create(Params.price.range,{
                        start: Profiles.price.start,
                        step: 1000,
                        connect: [true, false],
                        range: {
                            min: Profiles.price.from,
                            max: Profiles.price.to,
                        },
                        format: wNumb({
                            decimals: 0,
                        }),
                    });

                    // labels
                    Params.price.labelFrom.html('от ' + app.numberWithSpaces(Profiles.price.from) + ' ₽');
                    Params.price.labelTo.html('до ' + app.numberWithSpaces(Profiles.price.to) + ' ₽');

					// payment range
                    Params.payment = {
                        range: Nodes.fieldPayment.find('.input__range')[0],
                        inputUser: Nodes.fieldPayment.find('.input__field-user'),
                        labelFrom: Nodes.fieldPayment.find('.calculator__input-from'),
                        labelTo: Nodes.fieldPayment.find('.calculator__input-to'),
                    };

                    noUiSlider.create(Params.payment.range,{
                        start: 1000,
                        step: 1000,
                        connect: [true, false],
                        range: {
                            min: 0,
                            max: 100000,
                        },
                        format: wNumb({
                            decimals: 0,
                        }),
                    });

					// period range
                    Params.period = {
                        range: Nodes.fieldPeriod.find('.input__range')[0],
                        inputUser: Nodes.fieldPeriod.find('.input__field-user'),
                        labelFrom: Nodes.fieldPeriod.find('.calculator__input-from'),
                        labelTo: Nodes.fieldPeriod.find('.calculator__input-to'),
                    };

                    noUiSlider.create(Params.period.range,{
                        start: 10,
                        step: 1,
                        connect: [true, false],
                        range: {
                            min: 1,
                            max: 30,
                        },
                        format: wNumb({
                            decimals: 0,
                        }),
                    });

				},
                setupRangesEvents:function(){

					// payment
                    Params.payment.range.noUiSlider.on('update',function(values){
                        Loan.paymentInit = parseInt(values[0]);

                        // payment percent
                        if(Loan.price > 0) { Loan.paymentPercent = Math.round((values[0] * 100 / Loan.price) * 10) / 10; }
                        if(Loan.paymentPercent) { Nodes.labelPaymentPercent.html(Loan.paymentPercent + '%'); }

                        Params.payment.inputUser.val(app.numberWithSpaces(values[0]));

                        // label

                        Methods.calculateLoan();
                    });

                    Params.payment.inputUser.on('input keydown keyup mousedown mouseup select contextmenu drop',function(){
                        var field = {
                            old: this.dataset.old || '',
                            start: this.dataset.start || 0,
                            end: this.dataset.end || 0,
                        };

                        if(/^([0-9]+\s{0,1})+$/.test(this.value)) {
                            this.dataset.old = this.value;
                            this.dataset.start = this.selectionStart;
                            this.dataset.end = this.selectionEnd;
                        } else {
                            this.value = field.old;
                            this.setSelectionRange(field.start, field.end);
                        }

                    });

                    Params.payment.inputUser.on('change',function(){
                        Params.payment.range.noUiSlider.set([this.value, null]);
                    });


                    // price
                    Params.price.range.noUiSlider.on('update',function(values){
                        Loan.price = parseInt(values[0]);
                        Params.price.inputUser.val(app.numberWithSpaces(values[0]));

						// setup dependency
                        var options = {
                            range: {
                                min: parseInt(values[0] * Params.profile.payment.from / 1000) * 1000,
                                max: parseInt(values[0] * Params.profile.payment.to / 1000) * 1000,
                            },
						};

						// initial start
                        if(!Params.init){ options.start = parseInt(values[0] * .4); }


                        // labels
                        Params.payment.labelFrom.html('от ' + app.numberWithSpaces(options.range.min) + ' ₽');
                        Params.payment.labelTo.html('до ' + app.numberWithSpaces(options.range.max) + ' ₽');

                        // update
                        Params.payment.range.noUiSlider.updateOptions(options, true);
                    });

                    Params.price.inputUser.on('input keydown keyup mousedown mouseup select contextmenu drop',function(){
                        var field = {
                            old: this.dataset.old || '',
                            start: this.dataset.start || 0,
                            end: this.dataset.end || 0,
                        };

                        if(/^([0-9]+\s{0,1})+$/.test(this.value)) {
                            this.dataset.old = this.value;
                            this.dataset.start = this.selectionStart;
                            this.dataset.end = this.selectionEnd;
                        } else {
                            this.value = field.old;
                            this.setSelectionRange(field.start, field.end);
                        }

                    });

                    Params.price.inputUser.on('change',function(){
                        Params.price.range.noUiSlider.set([this.value, null]);
                    });


					// period
                    Params.period.range.noUiSlider.on('update',function(values){
                        Loan.period = parseInt(values[0]);
                        Params.period.inputUser.val(app.numberWithSpaces(values[0]));
                        Methods.calculateLoan();
                    });

                    Params.period.inputUser.on('input keydown keyup mousedown mouseup select contextmenu drop',function(){
                        var field = {
                            old: this.dataset.old || '',
                            start: this.dataset.start || 0,
                            end: this.dataset.end || 0,
                        };

                        if(/^([0-9]+\s{0,1})+$/.test(this.value)) {
                            this.dataset.old = this.value;
                            this.dataset.start = this.selectionStart;
                            this.dataset.end = this.selectionEnd;
                        } else {
                            this.value = field.old;
                            this.setSelectionRange(field.start, field.end);
                        }

                    });

                    Params.period.inputUser.on('change',function(){
                        Params.period.range.noUiSlider.set([this.value, null]);
                    });


				},
				eventChangeProfile:function(e){
					e.preventDefault();

					var $this = $(this);
					var thisValue = $this.data().value;
					if($this.hasClass('state-active')) { return false; }

                    Nodes.buttonProfile.removeClass('state-active');
                    $this.addClass('state-active');

                    // apply profile
                    if(Profiles.banks[thisValue]){
                       Methods.applyProfile(thisValue, Profiles.banks[thisValue]);
					}

				},
                applyProfile:function(bank, profile){

					// code
					Params.profile.bank = bank;

					// rate
                    Params.profile.rate = profile.rate;

                    // period
					Params.profile.period = profile.period;

                    // income rate
                    Params.profile.incomeRate = profile.incomeRate;

					// payment rate
					Params.profile.payment.from = profile.payment.from;
                    Params.profile.payment.to = profile.payment.to;
                    Params.price.inputUser.trigger('change');

                    // period
					var options = {
                        range:{
                            min: profile.period.from,
                            max: profile.period.to,
                        },
					};

                    Params.period.range.noUiSlider.updateOptions(options, true);

                    Params.period.labelFrom.html('от ' + options.range.min + Methods.periodSuffix(options.range.min));
                    Params.period.labelTo.html('до ' + options.range.max + Methods.periodSuffix(options.range.max));
                    Params.period.inputUser.trigger('change');

				},
				periodSuffix:function(year){
					year = parseInt(year) || 0;

					if(year === 0) { return ''; }

					var suffix = ' лет';
					if(year === 1) { suffix = ' года'; }
                    if(year === 21) { suffix = ' года'; }
                    if(year === 31) { suffix = ' года'; }
                    if(year === 41) { suffix = ' года'; }


					return suffix;

				},
				calculateLoan:function(){

					// ставка
                    Loan.rate = Params.profile.rate;


                    // ежемесячный платеж
                    Loan.payment = Loan.paymentInit;

					// сумма кредита
					Loan.sum = Loan.price - Loan.payment;

					// реальная сумма кредита
					Loan.sumReal = Loan.sum;

					// ставка в месяц
                    var i = parseFloat(Loan.rate / 1200);
                    var n = parseFloat(Loan.period * 12);
                    Loan.monthly = parseInt(Loan.sumReal * ((i * Math.pow(1+i,n)) / (Math.pow(1+i,n) - 1)));

                    // необходимый доход
					Loan.income = Math.round((Loan.monthly + Loan.monthly * Params.profile.incomeRate) / 1000) * 1000;


					//РНКБ Разные ставки

					// if(Params.profile.bank == "rnkb" && Loan.sum >= 5000000 && Loan.paymentPercent >= 50){
					// 	// console.log("Попали");
					// 	Loan.rate = 8.3
					// }


					//Альфа Банк Разные ставки

					// if(Params.profile.bank == "alphabank" && Loan.paymentPercent >= 20){
					// 	Loan.rate = 11.89
					// }

					//ВТБ Разные ставки

					// if(Params.profile.bank == "vtb" && Loan.paymentPercent >= 20){
					// 	Loan.rate = 10.4
					// }

					//Сбер Разные ставки

					// if(Params.profile.bank == "sber" && Loan.paymentPercent >= 20){
					// 	Loan.rate = 10.9
					// }

					//МКБ Разные ставки
					//
					// if(Params.profile.bank == "mkb" && Loan.paymentPercent >= 20){
					// 	Loan.rate = 9.99
					// }


					Methods.calculateHash();

                    Methods.showLabels();
				},
				calculateHash:function() {

                    var str = Loan.price + '+' + Loan.payment + '+' + Loan.period + '+' + Loan.rate + '+' + Loan.monthly + '+' + Loan.sumReal + '+' + Math.trunc((Loan.price + Loan.payment + Loan.monthly + Loan.sumReal - Loan.period) / 443);
                    Loan.hash = btoa(str);

                    // schedule
                    Nodes.buttonSchedule.attr('href', '/loan/schedule/' + Loan.hash + '/');

                    // share
                    Nodes.shareList.find('a').attr('data-url', 'https://izm-park.ru/loan/schedule/' + Loan.hash + '/');
                    window._goodshare.reNewAllInstance();

                },
                showLabels:function(){
					// labels
					if(Loan.rate) { Nodes.labelRate.html(Loan.rate); }
					if(Loan.monthly) { Nodes.labelMonthly.html(app.numberWithSpaces(Loan.monthly)); }
					if(Loan.sum) { Nodes.labelSum.html(app.numberWithSpaces(Loan.sum)); }
					if(Loan.income) { Nodes.labelIncome.html(app.numberWithSpaces(Loan.income)); }

				},
                shareScheduleOpen:function(e){
					e.preventDefault();
					$(this).closest('.calculator__share').toggleClass('is-show');
				},
				shareScheduleClose:function(e){
					e.preventDefault();
                    $(this).closest('.calculator__share').removeClass('is-show');
				}
			};

			Methods.init();

		},
	},
    calculatorDetail: {
        init($thisModule) {

            var Profiles = window.izmCalcData;

            var Params = {
                init:false,
                profile:{
                    bank: 'sber',
                    rate: 10.1,
                    incomeRate: .3,
                    payment:{
                        from: .1,
                        to: .97,
                    },
                    period:{
                        from: 3,
                        to: 30,
                    }
                },
                hash:'',
                price:{},
                payment:{},
                period:{},
            };

            var Loan = {
                rate: null,				// ставка годовая с учетом скидок, %
                price: null,			// стоимость недвижимости, руб
                paymentInit: null,		// первоначальный взнос, руб
                paymentPercent: null,	// первоначальный взнос в процентах от стоимости квартиры, %
                payment: null,			// первоначальный взнос со всеми скидками (мат капитал), руб
                period: null,			// Срок кредита, лет
                monthly: null,			// ежемесячный платеж, руб
                sum: null,				// сумма кредита, руб
                sumReal: null,			// реальная сумма кредита для формулы, руб
                income: null,			// необходимый доход, руб,
				overpay: null,			// переплата
            };

            var LoanDiscount = {
                rate: null,				// ставка годовая с учетом скидок, %
                monthly: null,			// ежемесячный платеж, руб
                overpay: null,			// переплата
				economy: null,			// экономия
			};

            var Nodes = {
                form: $thisModule.find('[data-n="form"]'),
                fieldPrice: $thisModule.find('[data-n="rangePrice"]'),
                fieldPayment: $thisModule.find('[data-n="rangePayment"]'),
                fieldPeriod: $thisModule.find('[data-n="rangePeriod"]'),
                swiperProfileButtons: $thisModule.find('[data-n="swiperProfileButtons"]'),
                buttonProfile: $thisModule.find('[data-n="buttonProfile"]'),

				labelPaymentPercent: $thisModule.find('[data-n="labelPaymentPercent"]'),
                labelRate: $thisModule.find('[data-n="labelRate"]'),
                labelMonthly: $thisModule.find('[data-n="labelMonthly"]'),
                labelMonthlySale10: $thisModule.find('[data-n="labelMonthlySale10"]'),
                labelMonthlySale20: $thisModule.find('[data-n="labelMonthlySale20"]'),
				labelPereplataSale10: $thisModule.find('[data-n="labelPereplataSale10"]'),
				labelPereplata01: $thisModule.find('[data-n="labelPereplata01"]'),
                labelFirst: $thisModule.find('[data-n="labelFirst"]'),
                labelFirstSale10: $thisModule.find('[data-n="labelFirstSale10"]'),
                labelFirstSale20: $thisModule.find('[data-n="labelFirstSale20"]'),
                labelSum: $thisModule.find('[data-n="labelSum"]'),
                labelIncome: $thisModule.find('[data-n="labelIncome"]'),
                labelOverpay: $thisModule.find('[data-n="labelOverpay"]'),
                labelOverpay20: $thisModule.find('[data-n="labelOverpay20"]'),

                labelRateDiscount: $thisModule.find('[data-n="labelRateDiscount"]'),
                labelMonthlyDiscount: $thisModule.find('[data-n="labelMonthlyDiscount"]'),
                labelMonthly0: $thisModule.find('[data-n="labelMonthly0"]'),
                labelOverpayDiscount: $thisModule.find('[data-n="labelOverpayDiscount"]'),
                labelEconomyDiscount: $thisModule.find('[data-n="labelEconomyDiscount"]'),
                labelEconomyDiscountSale20: $thisModule.find('[data-n="labelEconomyDiscountSale20"]'),

				labelCardMonthly: $('.js-loan-monthly'),

                buttonSchedule: $thisModule.find('[data-n="buttonSchedule"]'),
                buttonShareOpen: $thisModule.find('[data-n="buttonShareOpen"]'),
                buttonShareClose: $thisModule.find('[data-n="buttonShareClose"]'),
                shareList: $thisModule.find('[data-n="shareList"]'),
            };

            var Methods = {
                init:function() {

                    // setup swiper
                    var swiper = new Swiper(Nodes.swiperProfileButtons, {
                        slidesPerView: 'auto',
                        roundLengths: true,
                        resizeObserver: true,
                        navigation: {
                            nextEl: $thisModule.find('.bank-link-arrow.arrow-next'),
                            prevEl: $thisModule.find('.bank-link-arrow.arrow-prev'),
                        },
                    });

                    // setup events
                    Nodes.buttonShareOpen.on('click', Methods.shareScheduleOpen);
                    Nodes.buttonShareClose.on('click', Methods.shareScheduleClose);

                    // setup ranges
                    Methods.setupRanges();

                    // setup ranges events and dependency
                    Methods.setupRangesEvents();

                    // setup defaults
                    Methods.applyProfile('regular', Profiles.banks.regular);

                    // form events
                    Nodes.form.on('change',function(e){
                        e.preventDefault();
                        Methods.calculateLoan();
                    });

                    Nodes.form.on('submit',function(e){
                        e.preventDefault();
                        return false;
                    });

                    // ready
                    Params.init = true;

                },
                setupRanges:function(){

                    // price range
                    Params.price = {
                        range: Nodes.fieldPrice.find('.input__range')[0],
                        inputUser: Nodes.fieldPrice.find('.input__field-user'),
                        labelFrom: Nodes.fieldPrice.find('.calculator__input-from'),
                        labelTo: Nodes.fieldPrice.find('.calculator__input-to'),
                    };

                    noUiSlider.create(Params.price.range,{
                        start: Profiles.price.start,
                        step: 1000,
                        connect: [true, false],
                        range: {
                            min: Profiles.price.from,
                            max: Profiles.price.to,
                        },
                        format: wNumb({
                            decimals: 0,
                        }),
                    });

                    // labels
                    Params.price.labelFrom.html('от ' + app.numberWithSpaces(Profiles.price.from) + ' ₽');
                    Params.price.labelTo.html('до ' + app.numberWithSpaces(Profiles.price.to) + ' ₽');

                    // payment range
                    Params.payment = {
                        range: Nodes.fieldPayment.find('.input__range')[0],
                        inputUser: Nodes.fieldPayment.find('.input__field-user'),
                        labelFrom: Nodes.fieldPayment.find('.calculator__input-from'),
                        labelTo: Nodes.fieldPayment.find('.calculator__input-to'),
                    };


                    noUiSlider.create(Params.payment.range,{
                        start: 1000,
                        step: 1000,
                        connect: [true, false],
                        range: {
                            min: 0,
                            max: 100000,
                        },
                        format: wNumb({
                            decimals: 0,
                        }),
                    });

                    // period range
                    Params.period = {
                        range: Nodes.fieldPeriod.find('.input__range')[0],
                        inputUser: Nodes.fieldPeriod.find('.input__field-user'),
                        labelFrom: Nodes.fieldPeriod.find('.calculator__input-from'),
                        labelTo: Nodes.fieldPeriod.find('.calculator__input-to'),
                    };

                    noUiSlider.create(Params.period.range,{
                        start: 30,
                        step: 1,
                        connect: [true, false],
                        range: {
                            min: 1,
                            max: 30,
                        },
                        format: wNumb({
                            decimals: 0,
                        }),
                    });

                },
                setupRangesEvents:function(){

                    // payment
                    Params.payment.range.noUiSlider.on('update',function(values){
                        Loan.paymentInit = parseInt(values[0]);

                        // payment percent
                        if(Loan.price > 0) { Loan.paymentPercent = Math.round((values[0] * 100 / Loan.price) * 10) / 10; }
                        if(Loan.paymentPercent) { Nodes.labelPaymentPercent.html(Loan.paymentPercent + '%'); }

                        Params.payment.inputUser.val(app.numberWithSpaces(values[0]));

                        // label

                        Methods.calculateLoan();
                    });

                    Params.payment.inputUser.on('input keydown keyup mousedown mouseup select contextmenu drop',function(){
                        var field = {
                            old: this.dataset.old || '',
                            start: this.dataset.start || 0,
                            end: this.dataset.end || 0,
                        };

                        if(/^([0-9]+\s{0,1})+$/.test(this.value)) {
                            this.dataset.old = this.value;
                            this.dataset.start = this.selectionStart;
                            this.dataset.end = this.selectionEnd;
                        } else {
                            this.value = field.old;
                            this.setSelectionRange(field.start, field.end);
                        }

                    });

                    Params.payment.inputUser.on('change',function(){
                        Params.payment.range.noUiSlider.set([this.value, null]);
                    });


                    // price
                    Params.price.range.noUiSlider.on('update',function(values){
                        Loan.price = parseInt(values[0]);
                        Params.price.inputUser.val(app.numberWithSpaces(values[0]));

                        // setup dependency
                        var options = {
                            range: {
                                min: parseInt(values[0] * Params.profile.payment.from / 1000) * 1000,
                                max: parseInt(values[0] * Params.profile.payment.to / 1000) * 1000,
                            },
                        };

                        // initial start
						//Первоначальное положение ползунка (не может быть меньше минимального первоначального)
                        if(!Params.init){ options.start = parseInt(values[0] * .1); }


                        // labels
                        Params.payment.labelFrom.html('от ' + app.numberWithSpaces(options.range.min) + ' ₽');
                        Params.payment.labelTo.html('до ' + app.numberWithSpaces(options.range.max) + ' ₽');

                        // update
                        Params.payment.range.noUiSlider.updateOptions(options, true);
                    });

                    Params.price.inputUser.on('input keydown keyup mousedown mouseup select contextmenu drop',function(){
                        var field = {
                            old: this.dataset.old || '',
                            start: this.dataset.start || 0,
                            end: this.dataset.end || 0,
                        };

                        if(/^([0-9]+\s{0,1})+$/.test(this.value)) {
                            this.dataset.old = this.value;
                            this.dataset.start = this.selectionStart;
                            this.dataset.end = this.selectionEnd;
                        } else {
                            this.value = field.old;
                            this.setSelectionRange(field.start, field.end);
                        }

                    });

                    Params.price.inputUser.on('change',function(){
                        Params.price.range.noUiSlider.set([this.value, null]);
                    });


                    // period
                    Params.period.range.noUiSlider.on('update',function(values){
                        Loan.period = parseInt(values[0]);
                        Params.period.inputUser.val(app.numberWithSpaces(values[0]));
                        Methods.calculateLoan();
                    });

                    Params.period.inputUser.on('input keydown keyup mousedown mouseup select contextmenu drop',function(){
                        var field = {
                            old: this.dataset.old || '',
                            start: this.dataset.start || 0,
                            end: this.dataset.end || 0,
                        };

                        if(/^([0-9]+\s{0,1})+$/.test(this.value)) {
                            this.dataset.old = this.value;
                            this.dataset.start = this.selectionStart;
                            this.dataset.end = this.selectionEnd;
                        } else {
                            this.value = field.old;
                            this.setSelectionRange(field.start, field.end);
                        }

                    });

                    Params.period.inputUser.on('change',function(){
                        Params.period.range.noUiSlider.set([this.value, null]);
                    });


                },
                applyProfile:function(bank, profile){

                    // code
                    Params.profile.bank = bank;

                    // rate
                    Params.profile.rate = profile.rate;

                    // period
                    Params.profile.period = profile.period;

                    // income rate
                    Params.profile.incomeRate = profile.incomeRate;

                    // payment rate
                    Params.profile.payment.from = profile.payment.from;
                    Params.profile.payment.to = profile.payment.to;
                    Params.price.inputUser.trigger('change');

                    // period
                    var options = {
                        range:{
                            min: profile.period.from,
                            max: profile.period.to,
                        },
                    };

                    Params.period.range.noUiSlider.updateOptions(options, true);

                    Params.period.labelFrom.html('от ' + options.range.min + Methods.periodSuffix(options.range.min));
                    Params.period.labelTo.html('до ' + options.range.max + Methods.periodSuffix(options.range.max));
                    Params.period.inputUser.trigger('change');

                },
                periodSuffix:function(year){
                    year = parseInt(year) || 0;

                    if(year === 0) { return ''; }

                    var suffix = ' лет';
                    if(year === 1) { suffix = ' года'; }
                    if(year === 21) { suffix = ' года'; }
                    if(year === 31) { suffix = ' года'; }
                    if(year === 41) { suffix = ' года'; }


                    return suffix;

                },
                calculateLoan:function(){

                    // ставка
                    Loan.rate = Params.profile.rate;

                    // ежемесячный платеж
                    Loan.payment = Loan.paymentInit;

                    // сумма кредита
                    Loan.sum = Loan.price - Loan.payment;

                    // реальная сумма кредита
                    Loan.sumReal = Loan.sum;

                    // ставка в месяц
                    var i = parseFloat(Loan.rate / 1200);
                    var n = parseFloat(Loan.period * 12);
                    Loan.monthly = parseInt(Loan.sumReal * ((i * Math.pow(1+i,n)) / (Math.pow(1+i,n) - 1)));

                    // необходимый доход
                    Loan.income = Math.round((Loan.monthly + Loan.monthly * Params.profile.incomeRate) / 1000) * 1000;

                    // переплата
					Loan.overpay = parseInt((Loan.monthly * Loan.period * 12) - Loan.sum);
					Loan.overpaySale20 = parseInt((0.8*Loan.monthly * Loan.period * 12) - 0.8*Loan.sum);

                    // кредит со скидкой

                    LoanDiscount.rate = Profiles.banks.discount.rate;

                    // ставка в месяц
                    var i = parseFloat(LoanDiscount.rate / 1200);
                    var n = parseFloat(Loan.period * 12);
                    LoanDiscount.monthly = parseInt(Loan.sumReal * ((i * Math.pow(1+i,n)) / (Math.pow(1+i,n) - 1)));

                    // переплата
                    LoanDiscount.overpay = parseInt((LoanDiscount.monthly * Loan.period * 12) - Loan.sum);

                    // экономия
                    LoanDiscount.economy = parseInt(Loan.overpay - LoanDiscount.overpay);
                    LoanDiscount.economySale20 = parseInt(Loan.overpaySale20 - LoanDiscount.overpay);

                    Methods.calculateHash();

                    Methods.showLabels();

                },
                calculateHash:function() {

                    var str = Loan.price + '+' + Loan.payment + '+' + Loan.period + '+' + Loan.rate + '+' + Loan.monthly + '+' + Loan.sumReal + '+' + Math.trunc((Loan.price + Loan.payment + Loan.monthly + Loan.sumReal - Loan.period) / 443);
                    Loan.hash = btoa(str);

                    // schedule
                    Nodes.buttonSchedule.attr('href', '/loan/schedule/' + Loan.hash + '/');

                    // share
                    Nodes.shareList.find('a').attr('data-url', 'https://izm-park.ru/loan/schedule/' + Loan.hash + '/');
                    window._goodshare.reNewAllInstance();

                },
                showLabels:function(){

                    // labels
                    if(Loan.rate) { Nodes.labelRate.html(Loan.rate); }
                    if(Loan.monthly) { Nodes.labelMonthly.html(app.numberWithSpaces(Loan.monthly)); }
                    if(Loan.monthly) { Nodes.labelMonthlySale10.html(app.numberWithSpaces(Math.trunc(0.95*Loan.monthly))); }
                    if(Loan.monthly) { Nodes.labelMonthlySale20.html(app.numberWithSpaces(Math.trunc(0.8*Loan.monthly))); }
                    if(Loan.monthly) { Nodes.labelPereplataSale10.html(app.numberWithSpaces(Math.trunc(0.95*(Loan.price - Loan.paymentInit)*0.103))); }
                    if(Loan.monthly) { Nodes.labelPereplata01.html(app.numberWithSpaces(Math.trunc((Loan.price - Loan.paymentInit)*0.001))); }

                    if(Loan.monthly) { Nodes.labelFirst.html(app.numberWithSpaces(Loan.paymentInit)); }
                    if(Loan.monthly) { Nodes.labelFirstSale10.html(app.numberWithSpaces(0.95*Loan.paymentInit)); }
                    if(Loan.monthly) { Nodes.labelFirstSale20.html(app.numberWithSpaces(0.8*Loan.paymentInit)); }
                    if(Loan.overpay) { Nodes.labelOverpay.html(app.numberWithSpaces(Loan.overpay)); }
                    if(Loan.overpay) { Nodes.labelOverpay20.html(app.numberWithSpaces(Loan.overpaySale20)); }
                    if(Loan.economy) { Nodes.labelEconomy.html(app.numberWithSpaces(Loan.inceconomyome)); }

                    // dicount
                    if(LoanDiscount.rate){ Nodes.labelRateDiscount.html(app.numberWithSpaces(LoanDiscount.rate)); }

					// Кастыль для разного процента Альфабанка на калькуляторе в деталке апартамента
					// if (Loan.rate == 11.89 && Loan.paymentPercent >= 20){
					// 	Loan.rate = 11.39;
					// 	Nodes.labelRate.html(Loan.rate);
					// }
					// //Считаем платежи по ипотеке 0% на 18 месяцев
					//
					// var SummaPlatzhey = 0;
					// var n = 1;
					// var Platezh = Loan.monthly;
					// var PlataPoDolgu = 0;
					// var PlataPoProcentam = 0;
					// var OstatokDolga = 0;
					// while(n < 19){
					// 	PlataPoDolgu = Platezh - (Loan.sumReal - OstatokDolga)*(Loan.rate / 12 / 100);
					// 	OstatokDolga = OstatokDolga + PlataPoDolgu;
					// 	SummaPlatzhey = SummaPlatzhey + PlataPoDolgu;
					// 	n = n + 1;
					// };
					// console.log(SummaPlatzhey);




                    if(LoanDiscount.monthly){
                        Nodes.labelCardMonthly.html(app.numberWithSpaces(LoanDiscount.monthly));
                    	Nodes.labelMonthlyDiscount.html(app.numberWithSpaces(LoanDiscount.monthly));
                    }

					Nodes.labelMonthly0.html(app.numberWithSpaces((Loan.price - Loan.paymentInit) / Loan.period));

                    if(LoanDiscount.overpay){ Nodes.labelOverpayDiscount.html(app.numberWithSpaces(LoanDiscount.overpay)); }
                    if(LoanDiscount.economy){ Nodes.labelEconomyDiscount.html(app.numberWithSpaces(LoanDiscount.economy)); }
                    if(LoanDiscount.economy){ Nodes.labelEconomyDiscountSale20.html(app.numberWithSpaces(LoanDiscount.economySale20)); }

                },
                shareScheduleOpen:function(e){
                    e.preventDefault();
                    $(this).closest('.calculator__share').toggleClass('is-show');
                },
                shareScheduleClose:function(e){
                    e.preventDefault();
                    $(this).closest('.calculator__share').removeClass('is-show');
                }
            };

            Methods.init();

        },
    },
	documents: {
		init($documents) {
			const $select = $documents.find('.documents__select select');

			const $items = $documents.find('.documents__item');

			$select.on('change', () => {
				if ($select.val() === 'all') {
					$items.removeClass('is-hidden');
				} else {
					$items.addClass('is-hidden');
					$items.filter(`[data-type="${$select.val()}"]`).removeClass('is-hidden');
				}
			});
		},
	},
	cookie: {
		init($cookie) {
			if (localStorage.cookiesAgree !== 'yes') {
				setTimeout(() => {
					$cookie.fadeIn(250);
				}, 2000);
			}
			$cookie.find('.cookies__btn button').on('click', (e) => {
				e.preventDefault();
				localStorage.cookiesAgree = 'yes';
				$cookie.fadeOut(250);
			});
		},
	},
	progress: {
		init($progress) {
			let $video = $progress.find('.c-progress__video');

			let player;

			$progress.find('.c-progress__tabs button').on('click', (e) => {
				let $this = $(e.currentTarget);

				e.preventDefault();
				if ($video.find('video').length) {
					videojs($video.find('video')[0]).dispose();
				}

				var overrideNative = false;

				$video.append(`<video class="video-js"><source src="${$this.data('link')}" type="${$video.data('type')}"></video>`);

				const video = $video.find('video')[0];

				player = videojs(video, {
					html5: {
						// fill: true,
						fluid: true,
						liveTracker: {
							trackingThreshold: 5
						},
						hls: {
							overrideNative: !videojs.browser.IS_SAFARI,
						},
						nativeVideoTracks: !overrideNative,
						nativeAudioTracks: !overrideNative,
						nativeTextTracks: !overrideNative
					}
				});

				player.playsinline(true);
				player.play();
				$progress.find('.c-progress__tabs button').removeClass('is-active');
				$this.addClass('is-active');
			});

			$progress.find('.c-progress__fullscreen').on('click', (e) => {
				e.preventDefault();
				player.requestFullscreen();
			});

			$progress.find('.c-progress__vertical__close').on('click', (e) => {
				e.preventDefault();
				$progress.find('.c-progress__vertical').addClass('is-hidden');
			});
		},
	},
	process: {
		init($process) {
			const $filter = $process.find('.process-filter');

			const $container = $process.find('.process-container');

			const $dateButton = $process.find('.process-filter__date__item__button');

			let getDataTimeout;

			$process.find('.process-filter__date__label').on('click', (e) => {
				e.preventDefault();
				$(e.currentTarget).closest('.process-filter__date').addClass('is-show');
			});

			$document.on('click', (e) => {
				let $target = $(e.target);

				if (!$target.closest('.process-filter__date').length) {
					$process.find('.process-filter__date').removeClass('is-show');
					$process.find('.process-filter__date__item__label').removeClass('is-active');
					$process.find('.process-filter__date__item__list').removeClass('is-show');
				}
			});

			$process.find('.process-filter__date__item__label').on('click', (e) => {
				const $this = $(e.currentTarget);

				const $thisItem = $this.closest('.process-filter__date__item');

				const $thisDrop = $thisItem.find('.process-filter__date__item__list');

				e.preventDefault();

				if (!$this.hasClass('is-active')) {
					$process.find('.process-filter__date__item__label').removeClass('is-active');
					$process.find('.process-filter__date__item__list').removeClass('is-show');
					$this.addClass('is-active');
					$thisDrop.addClass('is-show');
				} else {
					$this.removeClass('is-active');
					$thisDrop.removeClass('is-show');
				}
			});

			$dateButton.on('click', (e) => {
				const $this = $(e.currentTarget);

				const $thisItem = $this.closest('.process-filter__date__item');

				const $thisItemLabel = $thisItem.find('.process-filter__date__item__label');

				const $thisButtons = $thisItem.find('.process-filter__date__item__button');

				e.preventDefault();

				if (!$thisButtons.filter('.is-active').length) {
					$this.addClass('is-active');
					$this.find('input').prop('checked', true).trigger('change');
					$thisItemLabel.text($this.text());
				} else if ($thisButtons.filter('.is-active').length === 1) {
					if ($this.hasClass('is-active')) {
						$this.removeClass('is-active');
						$this.find('input').prop('checked', false).trigger('change');
						$thisItemLabel.text($thisItemLabel.data('label'));
					} else {
						const array = [];

						let count = 0;

						$this.addClass('is-active');
						$thisButtons.find('input').prop('checked', false);

						$thisButtons.each((index, item) => {
							const $item = $(item);

							if ($item.hasClass('is-active')) {
								count++;
								array.push($item.text());
								$item.find('input').prop('checked', true);
							} else {
								if (count === 1) {
									$item.addClass('is-active');
									$item.find('input').prop('checked', true);
									array.push($item.text());
								}
							}
						});
						$this.find('input').prop('checked', true).trigger('change');

						$thisItemLabel.text(`${array[0]} - ${array[array.length - 1]}`);
					}
				} else {
					$thisButtons.removeClass('is-active');
					$thisButtons.find('input').prop('checked', false);
					$this.addClass('is-active');
					$this.find('input').prop('checked', true).trigger('change');
					$thisItemLabel.text($this.text());
				}
			});

			$filter.on('change', () => {
				clearTimeout(getDataTimeout);
				$container.addClass('is-loading');
				getDataTimeout = setTimeout(() => {
					$.ajax({
						type: $filter.attr('method'),
						url: $filter.attr('action'),
						data: $filter.serialize(),
						success(response) {
							$container.html(response);
							$container.removeClass('is-loading');
							initApps();
						},
					});
				}, 500);
			});
		},
	},
    tabsA:{
        init($thisModule) {

			var $links = $thisModule.find('[data-link]');
			var $tabs = $thisModule.find('[data-tab]');

            $links.on('click',function(e){
            	e.preventDefault();

            	var $this = $(this);
            	if($this.hasClass('state-active')) { return false; }

            	var link = $this.data().link || '-no-tab';
            	var $thisTab = $thisModule.find('[data-tab="'+link+'"]');

            	if($thisTab.length){

                    $links.removeClass('state-active');
                    $this.addClass('state-active');

                    $tabs.removeClass('state-active');
                    $thisTab.addClass('state-active');

				}

			});

		}
	},
};

app.global.init();

let initApps = () => {
	$('[data-app]').each((index, item) => {
		let $this = $(item);

		let split = $this.data('app').split('||');

		$.each(split, (appIndex, appName) => {
			let appNameCamel = false;

			if (appName.indexOf('-') !== -1) {
				appNameCamel = appName.replace(/(-|\s)(\S)/ug, (m) => m.toUpperCase()).replace(/-/ug, '');
			}

			if (app[appName] && $this.data(`${appName}-init`) !== true) {

				app[appName].init($this);
				$this.data(`${appName}-init`, true);
			} else if (app[appNameCamel] && $this.data(`${appName}-init`) !== true) {
				app[appNameCamel].init($this);
				$this.data(`${appName}-init`, true);
			}
		});
	});
};

(() => {
	function getCookie(name) {
		var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"))
		return matches ? decodeURIComponent(matches[1]) : undefined
	}
	const $disclamer = document.querySelector('.header__disclamer'),
		$closeBtn = document.querySelector('.js-disclamer-close');

	if($disclamer && $closeBtn){
		var cookie = getCookie('disclamer');

		if (cookie !== 'true'){
			$disclamer.classList.remove('_hidden');
		}

		$closeBtn.addEventListener('click', e => {
			$disclamer.classList.add('_hidden');
			if(cookie !== 'true') document.cookie = "disclamer=true;path=/;"

		});
	}
	
})();

initApps();
